import { render, staticRenderFns } from "./ChatGroupRtcBanner.vue?vue&type=template&id=800c082c&scoped=true"
import script from "./ChatGroupRtcBanner.vue?vue&type=script&lang=js"
export * from "./ChatGroupRtcBanner.vue?vue&type=script&lang=js"
import style0 from "./ChatGroupRtcBanner.vue?vue&type=style&index=0&id=800c082c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800c082c",
  null
  
)

export default component.exports